import { ChevronDown } from 'lucide-react';
import { useChannelBar } from './channelBarContext';

/**
 * The way back to a folded channel bar — see [ChannelBarContext] for why it
 * lives in the views rather than in the bar's own place.
 *
 * Renders nothing at all while the bar is showing: the bar carries its own fold
 * control, and a second one beside it would be two buttons for one state.
 *
 * `compact` drops the words for a host with no room for them — the inbox rail
 * once the agent has collapsed it to marks.
 */
export function ShowChannelBar({ compact }: { compact?: boolean }) {
  const { folded, show } = useChannelBar();
  if (!folded) return null;
  return (
    <button
      type="button"
      className={`cbar-show${compact ? ' compact' : ''}`}
      title="Show the channel bar — the channel tabs, Refresh, New message and New campaign"
      onClick={show}
    >
      <ChevronDown size={14} />
      {!compact && <span>Channel bar</span>}
    </button>
  );
}
